export default {"src":"/_next/static/media/yard-onboarding.d2c58c49.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};